import {
	computed,
	type EnvironmentInjector,
	Injectable,
	type Signal,
	signal,
	type Type,
	untracked,
} from '@angular/core';

import type { AppShellPanelContent } from '@efficiently/client-ui-app-shell';

@Injectable({ providedIn: 'root' })
export class DomainNavigatorStore {
	private readonly registeredContent = signal<AppShellPanelContent | undefined>(undefined);
	private readonly isOpenRequested = signal(false);

	public readonly content: Signal<AppShellPanelContent | undefined> = this.registeredContent.asReadonly();

	public readonly isOpen: Signal<boolean> = computed(
		() => this.isOpenRequested() && this.registeredContent() !== undefined,
	);

	public register(content: Type<unknown>, environmentInjector: EnvironmentInjector): void {
		this.registeredContent.set({ content, environmentInjector });
	}

	public unregister(): void {
		this.registeredContent.set(undefined);
		this.isOpenRequested.set(false);
	}

	public toggle(): void {
		if (untracked(this.registeredContent) === undefined) {
			return;
		}

		this.isOpenRequested.update(isOpen => !isOpen);
	}

	public close(): void {
		this.isOpenRequested.set(false);
	}
}
